<template>
    <div v-if="savingNotificationVisible" class="saving-notification saving-notification--vue">Sparar...</div>
</template>

<script>
    import { mapState } from "vuex"

    export default {
        computed: {
            ...mapState([
                "savingNotificationVisible"
            ]),
        }
    }
</script>

<style lang="scss">
    .saving-notification--vue {
        display: block !important;
    }
</style>



// WEBPACK FOOTER //
// assets/vue/houseModel/components/savingNotification.vue